import { IndentsI } from '../declarations';

export const getLoaderIndents = (isMobile: boolean) => {
  const indentStep = 56;
  const indents: IndentsI[] = new Array(isMobile ? 14 : 11).fill({
    avatarIndent: 14,
    dateTimeIndent: 14,
    messageIndent: 26,
    descriptionIndent: 38,
  });

  for (let i = 0; i < indents.length; i++) {
    indents[i] = {
      avatarIndent: i === 0 ? indents[i].avatarIndent : indents[i - 1].avatarIndent + indentStep,
      dateTimeIndent:
        i === 0 ? indents[i].dateTimeIndent : indents[i - 1].dateTimeIndent + indentStep,
      messageIndent: i === 0 ? indents[i].messageIndent : indents[i - 1].messageIndent + indentStep,
      descriptionIndent:
        i === 0 ? indents[i].descriptionIndent : indents[i - 1].descriptionIndent + indentStep,
    };
  }

  return indents;
};
